/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admincredit_Collatestbilling3Inputs */

const zh_admincredit_collatestbilling3 = /** @type {(inputs: Admincredit_Collatestbilling3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近变动`)
};

const en_admincredit_collatestbilling3 = /** @type {(inputs: Admincredit_Collatestbilling3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Activity`)
};

const es_admincredit_collatestbilling3 = /** @type {(inputs: Admincredit_Collatestbilling3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actividad`)
};

/**
* | output |
* | --- |
* | "Latest Activity" |
*
* @param {Admincredit_Collatestbilling3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const admincredit_collatestbilling3 = /** @type {((inputs?: Admincredit_Collatestbilling3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admincredit_Collatestbilling3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_admincredit_collatestbilling3(inputs)
	if (locale === "en") return en_admincredit_collatestbilling3(inputs)
	return es_admincredit_collatestbilling3(inputs)
});
export { admincredit_collatestbilling3 as "adminCredit_colLatestBilling" }